import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "grid"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "box-panel shadow-5 flex" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "col-12 lg:col-12" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_form_builder = _resolveComponent("form_builder")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_DynamicComponentBuilder = _resolveComponent("DynamicComponentBuilder")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showComponentForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.componentInputModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", { innerHTML: _ctx.componentInputHeader }, null, 8 /* PROPS */, _hoisted_5),
                    _withDirectives(_createVNode(_component_Button, {
                      style: {"cursor":"pointer"},
                      icon: "pi pi-arrow-left",
                      class: "mt-3 ml-auto p-button-rounded p-button-secondary p-button-outlined",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToOtherComponent()))
                    }, null, 512 /* NEED_PATCH */), [
                      [_directive_tooltip, 'Volver']
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_form_builder, {
                    container: _ctx.container,
                    componentId: _ctx.componentInputId,
                    applicationId: _ctx.applicationId,
                    applicationVersion: _ctx.applicationVersion,
                    preview: _ctx.preview,
                    attrsInput: _ctx.componentAttributesList
                  }, null, 8 /* PROPS */, ["container", "componentId", "applicationId", "applicationVersion", "preview", "attrsInput"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.showComponentFormDialog)
            ? (_openBlock(), _createBlock(_component_Dialog, {
                key: 1,
                visible: _ctx.componentInputModal,
                "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.componentInputModal) = $event)),
                maximizable: "",
                modal: "",
                styleClass: "mx-3 sm:mx-0 sm:w-full md:w-8 lg:w-6",
                contentStyleClass: "border-round-bottom border-top-1 surface-border p-0",
                onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.backToOtherComponent()))
              }, {
                header: _withCtx(() => [
                  _createElementVNode("span", { innerHTML: _ctx.componentInputHeader }, null, 8 /* PROPS */, _hoisted_7)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_form_builder, {
                    container: _ctx.container,
                    componentId: _ctx.componentInputId,
                    applicationId: _ctx.applicationId,
                    applicationVersion: _ctx.applicationVersion,
                    preview: _ctx.preview,
                    attrsInput: _ctx.componentAttributesList
                  }, null, 8 /* PROPS */, ["container", "componentId", "applicationId", "applicationVersion", "preview", "attrsInput"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["visible"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.ComponentsData)
        ? (_openBlock(), _createBlock(_component_DynamicComponentBuilder, {
            key: 0,
            data: _ctx.ComponentsData.children[0],
            "onUpdate:data": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ComponentsData.children[0]) = $event)),
            dataSources: _ctx.getComponenstDataSources,
            "onUpdate:dataSources": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.getComponenstDataSources) = $event)),
            rootParentAttr: _ctx.getRootAttributes,
            "onUpdate:rootParentAttr": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.getRootAttributes) = $event)),
            container: _ctx.container,
            rootParentId: _ctx.componentId
          }, null, 8 /* PROPS */, ["data", "dataSources", "rootParentAttr", "container", "rootParentId"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.showComponentForm || _ctx.showComponentFormDialog]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}